import { useMutation } from "react-query";
import { updateLastOpenedDuplicate } from "components/duplicate-staging/lib/productData";

export const useLastOpenedDuplicate = () => {
    return useMutation((taskKey) => updateLastOpenedDuplicate(taskKey));
};
